import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Facebook, Send, ArrowRight } from "lucide-react";
import Logo from "./Logo";
import { useLang } from "../context/LanguageContext";
import { useContent } from "../context/ContentContext";
import { sendInquiry } from "../lib/api";

const Footer = () => {
  const { t, lang } = useLang();
  const { CONTACT } = useContent();
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!email) return;
    sendInquiry("newsletter", { email }).catch(() => {});
    setDone(true);
    setEmail("");
    setTimeout(() => setDone(false), 3000);
  };

  const quick = [
    { to: "/about", label: t.nav.about },
    { to: "/gallery", label: t.nav.gallery },
    { to: "/halal-tours", label: t.nav.halal },
    { to: "/blog", label: t.nav.blog },
    { to: "/contact", label: t.nav.contact },
    { to: "/customize", label: t.nav.custom },
  ];
  const packs = [
    { to: "/umrah", label: t.nav.umrah },
    { to: "/hajj", label: t.nav.hajj },
    { to: "/hajj/pre-registration", label: t.nav.hajj_prereg },
    { to: "/hajj/requirements", label: t.nav.hajj_req },
  ];

  return (
    <footer className="footer-gradient text-white/85 relative overflow-hidden">
      <div className="absolute inset-0 pattern-overlay opacity-25" />
      <div className="relative max-w-7xl mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Logo light size="lg" />
            <p className="mt-5 text-sm leading-relaxed">{t.footer.about}</p>
            <a
              href={CONTACT.facebook}
              target="_blank"
              rel="noreferrer"
              className="mt-5 inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/10 hover:bg-jannah-gold hover:text-white"
            >
              <Facebook size={18} />
            </a>
          </div>

          <div>
            <h4 className="text-jannah-gold text-xl mb-5">{t.footer.quick}</h4>
            <ul className="space-y-3 text-sm">
              {quick.map((q) => (
                <li key={q.to}>
                  <Link to={q.to} className="inline-flex items-center gap-2 hover:text-jannah-gold-light">
                    <ArrowRight size={13} className="text-jannah-gold" /> {q.label}
                  </Link>
                </li>
              ))}
              {packs.map((q) => (
                <li key={q.to}>
                  <Link to={q.to} className="inline-flex items-center gap-2 hover:text-jannah-gold-light">
                    <ArrowRight size={13} className="text-jannah-gold" /> {q.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-jannah-gold text-xl mb-5">{t.footer.contact}</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-jannah-gold shrink-0 mt-0.5" />
                <span>{lang === "en" ? CONTACT.address_en : CONTACT.address_bn}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-jannah-gold shrink-0" />
                <a href={`tel:${CONTACT.phone}`} className="hover:text-jannah-gold-light">{CONTACT.phone}</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-jannah-gold shrink-0" />
                <a href={`mailto:${CONTACT.email}`} className="hover:text-jannah-gold-light">{CONTACT.email}</a>
              </li>
              <li className="flex items-center gap-3">
                <Clock size={18} className="text-jannah-gold shrink-0" />
                <span>{t.top_hours}</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-jannah-gold text-xl mb-5">{t.footer.newsletter}</h4>
            <p className="text-sm mb-4">{t.footer.newsletter_sub}</p>
            <form onSubmit={submit} className="flex">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t.contact.email}
                className="flex-1 min-w-0 px-4 py-3 rounded-l-full bg-white/10 text-white placeholder:text-white/50 text-sm focus:outline-none focus:bg-white/15"
              />
              <button
                type="submit"
                className="px-4 rounded-r-full bg-jannah-gold text-white hover:bg-jannah-gold-light"
                aria-label="Subscribe"
              >
                <Send size={18} />
              </button>
            </form>
            {done && <p className="mt-3 text-jannah-gold-light text-sm">JazakAllah! ✓</p>}
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-white/70">
          <p>© {new Date().getFullYear()} Fly Jannah. {t.footer.rights}</p>
          <p>{t.footer.made}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
